/**
 * RightsTreeEnum representing the hierarchical structure of system rights
 * Each right is represented as a constant with its unique identifier
 */


export const RightsTreeEnum = Object.freeze({
    // Root
    ROOT: '7df1fcad-808b-43a7-a24e-0da4b1c97bf6',

    // Livello 1
    ADMINISTRATION: '0ba7a27b-db3d-4e23-bac7-9213bdf17a21',
    DARM: '065658af-dca0-4947-b45f-541b9fd7c79c',
    SECURITY: '659155fb-9d29-441c-bbd4-69d94f6b10ba',
    DMS: 'ECD9BB7D-3923-4CE5-A96A-C2B4BF2B6C85',

    // Administration - Livello 2
    USER_AND_GROUP_MANAGEMENT: 'cc213575-40b3-429e-88ef-a8cf3f37c109',
    SYSTEM_CONFIGURATION: '13b6dbc4-2d6d-4bcd-8c99-ccb51dcd69d5',
    DICTIONARY: 'dfcdbc27-0026-4978-ab27-7a83b9438506', 
    ORGANIZATIONA_CHART: '6feec3bd-d4c8-4c65-b00a-1a153404a627', 

    // DARM - Livello 2
    FORM_BUILDER: 'cc14d3d0-da88-4090-8551-99823881069e',
    HAND_HYGIENE: 'aba8f100-6776-4e30-9b8e-eddad1246356',
    IMPORT_DATA: '84a56d0f-38f5-4350-b29b-e26afbdfd8a1',
    POWER_BI_REPORTS: '96d7a659-be13-4556-bed5-9509d5ba4227',

    // FORM BUILDER - Livello 3
    FORM_VALIDATE: '59b0cf55-db29-4236-8eae-602b4a5b7466',
    FORM_ASSIGN: 'ee044ac5-0061-4187-8083-e0858a0f9b2b',

    // HAND HYGIENE - Livello 3
    COMPILE_HAND_HYGIENE: 'ae027625-9473-41f0-9658-b8b64c4448d6',

    // SECURITY - Livello 2
    RIGHTS_TREE_MANAGEMENT: 'c3ade10a-05fe-4641-86c9-5ce5cf1345e2',
    PERMISSIONS_MANAGEMENT: 'c36a0e92-e1d4-4d9d-b555-b8e16f8ec4d4',
    OBJECT_HISTORY: '7af5ee8a-ce28-40ce-ac91-237634747de3',
});
